var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"song-chooser"},[_vm._v(" 📁choose songs "),_c('input',{staticClass:"file-selector",attrs:{"multiple":"","type":"file","accept":".zip"},on:{"change":_vm.handleChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }